var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var UrlUtils = require('../../utils/urlUtils');
var LoginActions = require('../../actions/LoginActions');
var defaultMessages = require('../../i18n/messages/default');

class HandleToastr extends React.Component {

    componentDidMount() {
        this.renderMessageToastr();
    }

    renderMessageToastr() {
        const toastrMessageKey = UrlUtils.fetchToastrMessage();
        if (toastrMessageKey && !_.isEmpty(toastrMessageKey)) {
            const toastrType = toastrMessageKey.split('.')[0];
            const message = this.props.intl.formatMessage(defaultMessages[toastrMessageKey]);
            LoginActions.triggerToast(message,toastrType,true);
        }
    }

    render() {
        return (
            <div className='toasters'></div>
        )
    }
}

module.exports = injectIntl(HandleToastr);